import { createReducer } from '@reduxjs/toolkit';
import { getPartnersPage } from '../actions/partnersPage';

const initialState = {
  loading: true,
  data: {},
};
export default createReducer(initialState, (builder) => {
  builder.addCase(getPartnersPage.fulfilled, (state, action) => ({
    ...state,
    data: action.payload,
    loading: false,
  }));
});
